// import gsap from 'gsap'
// import ScrollTrigger from 'gsap/ScrollTrigger'
// import ScrollToPlugin from 'gsap/ScrollToPlugin'
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export class ClassMotionCss {
  constructor() {
    this.motionElems;
  }

  // -----------------------------
  // group trigger (parent -> children stagger)
  // -----------------------------
  _initMotionGroups = () => {
    const groups = document.querySelectorAll('[data-motion-group="stagger"]');
    if (!groups.length) return;

    groups.forEach((group) => {
      // 親側の start / stagger
      const start = group.getAttribute("data-start") ?? "0 90%";
      const stagger = Number(group.getAttribute("data-stagger") ?? 0.12);

      // ★ 追加：親遅延（ms → s変換）
      const lazyTimeAttr = group.getAttribute("data-lazy-time");
      const groupDelay = lazyTimeAttr ? Number(lazyTimeAttr) / 1000 : 0;

      // グループ対象：slide-up/fade/opacity系の .js-motion だけ
      const items = group.querySelectorAll(
        '.js-motion[data-motion="slide-up"],' +
        '.js-motion[data-motion="fade"],' +
        '.js-motion[data-motion="opacity"],' +
        '.js-motion[data-motion="opacity-blur"]'
      );

      if (!items.length) return;

      // 二重発火防止：個別ScrollTriggerを作らせない
      items.forEach((el) => el.setAttribute("data-skip-trigger", "true"));

      ScrollTrigger.create({
        trigger: group,
        start,
        markers: false,
        once: true, // 1回だけ（戻ってきても再発火したいなら false に）
        onEnter: () => {
          items.forEach((el, i) => {
            // CSS側が transition-delay: var(--delay); 等になっている前提

            const totalDelay = groupDelay + (i * stagger);
            el.style.setProperty("--delay", `${totalDelay}s`);
            // el.style.setProperty("--delay", `${i * stagger}s`);
            el.classList.add("is-motion");
          });
        },
      });
    });
  };

  excute = () => {
    const _this = this;

    // 先にグループを初期化（重要：個別より先）
    this._initMotionGroups();

    this.motionElems = document.querySelectorAll(".js-motion");

    setTimeout(function () {
      _this.motionElems.forEach((motionElem) => {
        const motionType = motionElem.getAttribute("data-motion");
        const lazyFlag = motionElem.getAttribute("data-lazy");

        let dataStart = "0 90%";
        if (motionElem.getAttribute("data-start") != null) {
          dataStart = motionElem.getAttribute("data-start");
        }

        if (motionType == "img-parallax-y") {
          let parallaxElem = motionElem.querySelectorAll("img")[0];
          if (parallaxElem == undefined)
            parallaxElem = motionElem.querySelectorAll("div")[0];
          if (parallaxElem == undefined)
            parallaxElem = motionElem.querySelectorAll("span")[0];

          const val = motionElem.getAttribute("data-motion-val");

          gsap.fromTo(
            parallaxElem,
            { yPercent: 0 },
            {
              yPercent: val,
              ease: "none",
              scrollTrigger: {
                trigger: motionElem,
                start: "top bottom",
                end: "bottom top",
                scrub: 1,
              },
            },
          );
        }

        if (
          motionType == "slide-up" ||
          motionType == "fade" ||
          motionType == "opacity" ||
          motionType == "opacity-blur"
        ) {
          // ★ グループ対象は個別トリガーを作らない
          if (motionElem.getAttribute("data-skip-trigger") === "true") return;

          ScrollTrigger.create({
            trigger: motionElem,
            start: dataStart,
            markers: false,
            onEnter: () => {
              // 既存の lazy（横方向で遅延）仕様はそのまま残す
              if (lazyFlag != null) {
                const x = motionElem.getBoundingClientRect().left;
                let delay = Math.floor(x * 0.06) * 0.01 + "s";
                motionElem.style.setProperty("--delay", delay);
              }
              motionElem.classList.add("is-motion");
            },
          });
        }

        if (motionType == "mask") {
          ScrollTrigger.create({
            trigger: motionElem,
            start: "0 90%",
            markers: false,
            onEnter: () => {
              motionElem.classList.add("is-motion");
            },
          });
        }

        if (motionType == "slide-up-img") {
          ScrollTrigger.create({
            trigger: motionElem,
            start: "0 80%",
            markers: false,
            onEnter: () => {
              motionElem.classList.add("is-motion");
            },
          });
        }

        if (motionType == "img-slide-in") {
          ScrollTrigger.create({
            trigger: motionElem,
            start: "0 90%",
            markers: false,
            onEnter: () => {
              motionElem.classList.add("is-motion");
            },
          });
        }

        if (motionType == "img-fixed") {
          ScrollTrigger.create({
            trigger: motionElem,
            start: "0 100%",
            end: "100% 0",
            markers: false,
            onEnter: () => {
              motionElem.classList.add("is-motion");
            },
            onEnterBack: () => {
              motionElem.classList.add("is-motion");
            },
            onLeaveBack: () => {
              motionElem.classList.remove("is-motion");
            },
            onLeave: () => {
              motionElem.classList.remove("is-motion");
            },
          });
        }

        if (motionType == "img-parallax-x") {
          const parallaxImgElem = motionElem.querySelectorAll("img")[0];
          gsap.fromTo(
            parallaxImgElem,
            { xPercent: 0 },
            {
              xPercent: -0,
              ease: "none",
              scrollTrigger: {
                trigger: motionElem,
                start: "top bottom",
                end: "bottom top",
                scrub: 1,
              },
            },
          );
        }

        if (motionType == "img-parallax-w100-l") {
          const offsetH = motionElem.offsetHeight;
          const parallaxImgElem = motionElem.querySelectorAll("img")[0];
          const triggerTargetElem = motionElem.getAttribute("data-trigger-target");

          gsap.fromTo(
            parallaxImgElem,
            { xPercent: 0 },
            {
              xPercent: 10,
              ease: "none",
              scrollTrigger: {
                trigger: triggerTargetElem,
                start: "0-=" + offsetH + " 100%",
                markers: false,
                scrub: 1,
              },
            },
          );
        }
      });

      // 画像遅延ロード等で高さが後から変わるページなら保険
      ScrollTrigger.refresh();
    }, 100);
  };
}
